import CollectionPayload from '@libraries/api/home-setting';
import VideoPayload from '@libraries/api/youtube';
import BannerPayload from '@libraries/api/banners';
import FetchData from '@utils/fetch-data';
import { notification } from 'antd';
import { history, IFetchData } from 'asumsi-components';
import { Dispatch, SetStateAction, useState } from 'react';

export default function useAction() {
    const [isLoader, setIsLoader]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);
    const [data, setData]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState();

    const [videos, setViedos]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState();

    const getData = async (params?: any) => {
        const payload: IFetchData = CollectionPayload.read(params);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setData(response.data.data);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getVideos = async (params?: any) => {
        const payload: IFetchData = VideoPayload.read(params);
        try {
            const response: any = await FetchData({ ...payload });
            setViedos(response.data.data);
        } catch (error) {
            const { response } = error;
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const postData = async (params: any) => {
        const payload: IFetchData = CollectionPayload.post(params);

        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil simpan data',
            });
            history.push({
                pathname: '/settings/home-page',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal menyimpan data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const uploadBanner = async (params: any) => {
        const param = new FormData()
        Object.keys(params).map((key: any) => param.append(key, params[key]));
        const payload: IFetchData = BannerPayload.post(param);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setIsLoader(false);
            return response.data.data;
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal upload image",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    return {
        data,
        getData,
        isLoader,
        setIsLoader,
        postData,
        getVideos,
        videos,
        uploadBanner
    };
}



// WEBPACK FOOTER //
// ./src/pages/homepage-form/hooks/useAction.tsx